import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import A18n from '../../../../../common/A18n';
import { getViewCount } from '../../../../../../redux/selectors/myartprice/data';

const ViewCount = ({ idlot }) => {
  const viewCount = useSelector(state => getViewCount(state, { idlot }));
  const intl = useIntl();

  if (!viewCount) return null;

  return (
    <div className="font font-999 font-12 col-xs-12 text-center">
      <A18n rsx="myartprice.history.html.m2" replace={[['%nb_times%', viewCount.count]]} />
      <br />
      <A18n rsx="myartprice.history.html.m4" replace={[['%last_view_date%', intl.formatDate(viewCount.maxDt)]]} />
    </div>
  );
};

export default ViewCount;
